<mat-icon>{{icon}}</mat-icon>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/water.fall.container/card/action/card.action.component.html